<script lang="ts" setup>
import { translate } from '@/i18n/i18n.ts'
</script>

<template>
  <div class="purchase-date-modal">
    <p
      class="purchase-date-modal__p--no-margin modal__text"
      v-html="translate('modal_content.purchaseDate.paragraph_1')"
    />
  </div>
</template>

<style lang="scss" scoped>
@import 'purchase-date-modal';
</style>
